<template>
  <div class="ImagePicker">
    <template v-if="showEntry">
    <!-- 图片显示/选择入口 -->
    <div class="imagePickerBox" :style="{ width: width + 'px', height: height + 'px' }">
      <template v-if="value">
        <el-image class="imagePickerImg" :src="value" :preview-src-list="[value]" fit="cover"></el-image>
        <div class="imagePickerMask">
          <span @click.stop="openPicker">更换</span>
          <span @click.stop="removeImage">删除</span>
        </div>
      </template>
      <div v-else class="imagePickerEmpty" @click="openPicker">
        <span class="icon iconfont iconicon-test20 imagePickerEmptyIcon"></span>
        <span class="imagePickerEmptyText">选择图片</span>
      </div>
    </div>
    <p class="imagePickerTip" v-if="tip" v-text="tip"></p>
    </template>

    <!-- 图片空间弹窗 -->
    <div class="ModalBox ImagePickerModal" v-if="showPicker">
      <div class="ModalMain">
        <div class="ModalMainHead">
          图片空间
          <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback" @click="showPicker = false"></span>
        </div>
        <div class="TableHead ModalMainImgHead">
          <ul class="TableHeadLeft">
            <li class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius NoSelect">
              <span class="icon iconfont iconicon-test20"></span>
              <template v-if="uploadLoading">上传中...</template>
              <template v-else>上传图片</template>
              <input type="file" class="upload" @change="AddImg()" ref="imgs" multiple accept="image/png,image/jpeg,image/gif,image/jpg" :disabled="uploadLoading" />
            </li>
          </ul>
          <ul class="TableHeadRight">
            <div class="SelectStyle ModalSelect" @click.stop="toggleGroup" v-if="groups.length > 0">
              <div class="SelectStyleValue">{{ groups[groupIx].group_name }}</div>
              <ul class="OptionStyleBox" v-if="groupActive">
                <ul class="OptionStyleMain">
                  <li class="OptionStyleRow" v-for="(item, index) in groups" v-bind:key="index" v-text="item.group_name" @click="changeGroup(index, item.space_group_id)"></li>
                </ul>
              </ul>
              <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
            </div>
          </ul>
          <ul class="clear"></ul>
        </div>
        <div class="ModalMainBox ModalMainImgBox">
          <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!imgsList"></K-Transition>
          <div v-else :class="{ ModalMainBoxScroll: imgsList.length > 5 }">
            <table class="table ImagePickerTable">
              <tbody class="TRHoverStyle">
                <tr v-for="(item, index) in imgsList" v-bind:key="index" @click="selectImg(item.url, item.name)">
                  <td class="ModalMaiImgMainBox">
                    <div class="ModalMaiImgMain backImg" :style="{ backgroundImage: 'url(' + item.url + ')' }"></div>
                  </td>
                  <td v-text="item.name"></td>
                  <td class="ModalMaiImgIconBox"><span class="icon iconfont iconicon-test55 ModalMaiImgIcon"></span></td>
                </tr>
              </tbody>
            </table>
            <!-- 分页器 -->
            <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>
          </div>
        </div>
        <div class="ModalMainFoot">
          <div class="ModalMainFootRight btnArray">
            <a class="btnStyleTwo btnRadius grayBackColor" @click="showPicker = false">取消</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Compressor from 'compressorjs'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
export default {
  name: 'ImagePicker',
  components: {
    'K-Paging': Paging,
    'K-Transition': Transition
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    },
    tip: {
      type: String,
      default: ''
    },
    //是否显示内置的"选择图片"入口（false 时仅作为弹窗，由父组件外部触发）
    showEntry: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showPicker: false,  //是否显示图片空间弹窗
      uploadLoading: false,
      page: 1,
      totalPages: 1,
      pid: 0,  //图片空间分组id
      isLoding: true,
      subHint: '数据加载中...',
      imgsList: null,
      groups: [],  //图片空间分组
      groupIx: 0,
      groupActive: false
    }
  },
  created () {
    axios.defaults.headers.common['token'] = localStorage.getItem("wwmxt_Token");
  },
  methods: {
    //打开图片空间
    openPicker () {
      this.showPicker = true;
      this.page = 1;
      this.totalPages = 1;
      this.imgsList = null;
      this.subHint = '数据加载中...';
      if (this.groups.length == 0) {
        this.GetGroups();
      }
      this.GetImgsList();
    },
    //获取图片空间分组
    GetGroups () {
      axios.get(this.GetServerUrl(1) + "space_group_list/img")
      .then((response) => {
        this.groups = response.data.meta || [];
        this.groups.unshift({ space_group_id: 0, group_name: "默认分组" });
        this.groupIx = 0;
        this.pid = 0;
      }).catch(() => {
        this.groups = [{ space_group_id: 0, group_name: "默认分组" }];
        this.groupIx = 0;
        this.pid = 0;
      })
    },
    //获取图片列表
    GetImgsList () {
      this.isLoding = true;
      axios.get(this.GetServerUrl(1) + "resource/img/" + this.pid + "/" + this.page)
      .then((response) => {
        let datas = [];
        let meta = response.data.meta || {};
        for (let item in meta.data) {
          datas.push(meta.data[item]);
        }
        this.imgsList = datas;
        this.isLoding = false;
        //总页数
        this.totalPages = meta.last_page || 1;
      }).catch((error) => {
        this.subHint = this.ErrorHint(error);
        this.isLoding = false;
        this.imgsList = null;
      })
    },
    //切换分组下拉
    toggleGroup () {
      this.groupActive = !this.groupActive;
    },
    //选择分组
    changeGroup (index, id) {
      this.groupActive = false;
      if (this.groupIx == index) {
        return;
      }
      this.groupIx = index;
      this.pid = id;
      this.page = 1;
      this.imgsList = null;
      this.subHint = '数据加载中...';
      this.GetImgsList();
    },
    //压缩单个图片（gif 保持原图，避免丢失动画）
    compressImage (file) {
      return new Promise((resolve) => {
        if (file.type === 'image/gif') {
          resolve(file);
          return;
        }
        // 小于 300KB 的图片不压缩
        if (file.size < 300 * 1024) {
            resolve(file);
            return;
        }
        //png 转为 webp，jpg / webp 保持原格式
        let mimeType = 'auto';
        if (file.type === 'image/png') {
          mimeType = 'image/webp';
        } else if (file.type === 'image/jpeg' || file.type === 'image/webp') {
          mimeType = file.type;
        }
        new Compressor(file, {
          quality: 0.7,
          maxWidth: 1080,  //最大宽度，超过则等比缩放
          maxHeight: 1080, //最大高度
          mimeType: mimeType,
          success (result) {
            // console.log(`${file.name}压缩前尺寸:${file.size}, ${result.name}压缩后尺寸:${result.size}`)
            resolve(result);
          },
          error (err) {
            console.warn('图片压缩失败，使用原图上传：', err);
            resolve(file);
          }
        });
      });
    },
    //上传图片到图片空间
    AddImg () {
      let inputDOM = this.$refs.imgs;
      let files = Array.prototype.slice.call(inputDOM.files || []);
      if (!files.length) {
        return;
      }
      this.uploadLoading = true;
      //上传前先压缩
      Promise.all(files.map((file) => this.compressImage(file))).then((compressedFiles) => {
        //FormDatas格式提交
        let FormDatas = new FormData();
        FormDatas.append("type", "img");
        FormDatas.append("space_group_id", this.pid);
        for (let i = 0; i < compressedFiles.length; i++) {
          FormDatas.append("resource[]", compressedFiles[i], files[i].name);
        }
        return axios({
          method: "post",
          url: this.GetServerUrl(1) + "resource",
          headers: {
            "Content-Type": "multipart/form-data"
          },
          data: FormDatas
        });
      }).then((response) => {
        this.uploadLoading = false;
        inputDOM.value = '';
        if (response.data.meta && files.length > response.data.meta.length) {
          this.$message({ type: 'error', message: '文件必须为图片格式' });
        } else {
          this.$message({ type: 'success', message: response.data.message || '上传成功' });
        }
        this.GetImgsList();
      }).catch((error) => {
        this.uploadLoading = false;
        inputDOM.value = '';
        this.$message({ type: 'error', message: this.ErrorHint(error) });
      })
    },
    //选择图片
    selectImg (url, name) {
      this.showPicker = false;
      this.$emit('input', url);
      this.$emit('change', url, name);  //name 供需要回填文件名的页面使用
    },
    //删除图片
    removeImage () {
      this.$emit('input', '');
      this.$emit('change', '');
    },
    ChangePage (data) {  //上下翻页
      if (data.te == 1) {
        if (this.page > 1) {
          this.page--;
          this.GetImgsList();
        }
      } else {
        if (this.page < this.totalPages) {
          this.page++;
          this.GetImgsList();
        }
      }
    },
    SkipPage (data) {  //跳转分页
      this.page = data.ix;
      this.GetImgsList();
    }
  }
}
</script>

<style scoped>
  .ImagePicker{
    display: inline-block;
    vertical-align: top;
  }
  .imagePickerBox{
    position: relative;
    overflow: hidden;
    border: 1px dashed #DCDFE6;
    border-radius: 4px;
    background-color: #FAFAFA;
    cursor: pointer;
    box-sizing: border-box;
  }
  .imagePickerBox:hover{
    border-color: #409EFF;
  }
  .imagePickerImg{
    display: block;
    width: 100%;
    height: 100%;
  }
  .imagePickerEmpty{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #909399;
  }
  .imagePickerEmptyIcon{
    font-size: 24px;
    color: #409EFF;
    line-height: 1;
  }
  .imagePickerEmptyText{
    font-size: 12px;
    margin-top: 6px;
  }
  .imagePickerMask{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.45);
    opacity: 0;
    transition: opacity .2s;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;
  }
  .imagePickerBox:hover .imagePickerMask{
    opacity: 1;
  }
  .imagePickerMask span{
    color: #FFF;
    font-size: 12px;
    padding: 4px 6px;
    cursor: pointer;
    border-radius: 3px;
  }
  .imagePickerMask span:hover{
    color: #409EFF;
  }
  .imagePickerTip{
    font-size: 12px;
    color: #909399;
    line-height: 22px;
    margin-top: 6px;
  }
  /* 弹窗层级需要高于外层 Modal */
  .ImagePickerModal{
    z-index: 2000 !important;
  }
</style>
